(() => {
  const initializeReviews = root => {
    root.querySelectorAll('[data-cc-reviews]').forEach(region => {
      if (region.dataset.ccReady) return;
      region.dataset.ccReady = 'true';
      const filters = region.querySelector('.ccp-filters');
      const status = region.querySelector('[data-cc-review-count]');
      const cards = [...region.querySelectorAll('[data-cc-review]')];
      if (!filters || !status) return;
      filters.hidden = false;
      const update = topic => {
        let visible = 0;
        cards.forEach(card => {
          card.hidden = topic !== 'all' && !card.dataset.topics.split(/\s+/).includes(topic);
          if (!card.hidden) visible++;
        });
        filters.querySelectorAll('[data-cc-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ccFilter === topic)));
        status.textContent = status.dataset.countTemplate.replace('__COUNT__', String(visible));
      };
      filters.addEventListener('click', event => {
        const button = event.target.closest('[data-cc-filter]');
        if (button) update(button.dataset.ccFilter);
      });
      update('all');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeReviews(document), {once:true}); else initializeReviews(document);
  document.addEventListener('shopify:section:load', event => initializeReviews(event.target));
})();
